import { Validator } from '@vista-digital/validator';
/**
 * Determines the booking fee mode.
 */
export var BookingFeeMode;
(function (BookingFeeMode) {
    /**
     * Ticket prices are displayed inclusive of their booking fees.
     */
    BookingFeeMode["Inclusive"] = "Inclusive";
    /**
     * Ticket prices are displayed exclusive of their booking fees, which are displayed as a separate line.
     */
    BookingFeeMode["Exclusive"] = "Exclusive";
})(BookingFeeMode || (BookingFeeMode = {}));
export const bookingFeeModeValidator = Validator.oneOf(Object.values(BookingFeeMode));
//# sourceMappingURL=booking-fee-mode.js.map